export class QuarantineDetailCreate {
  public QuarantineId?: number;
  public QuarantineReasonId?: number;
  public QuarantineReasonStatus?: number;
  public AccomplishDate?: Date;
}

export class QuarantineDetailEdit {
  public Id?: number;
  public QuarantineId?: number;
  public QuarantineReasonId?: number;
  public QuarantineReasonStatus?: number;
  public AccomplishDate?: Date;
}
